// About Social Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
    console.log('About Social page loaded');

    // Initialize page functionality
    initAboutSocialPage();
});

function initAboutSocialPage() {
    // Add any specific functionality for the About Social page here

    // Example: Smooth scrolling for navigation links
    const navLinks = document.querySelectorAll('.about-hero__nav-link');
    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Add smooth scrolling or other navigation functionality
            console.log('Navigation link clicked:', this.textContent);
        });
    });

    // Example: Animate content on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    // Observe content sections for animation
    const contentSections = document.querySelectorAll('.about-content__text');
    contentSections.forEach(section => {
        section.style.opacity = '0';
        section.style.transform = 'translateY(20px)';
        section.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(section);
    });
}
